// istanbul ignore file
import { cva } from "cva";
import { TagToClassNameMap } from "~/lib/shared/html-utils";

const heroHeadlineFontStyle = cva(
  "text-landing-page-hero-mobile font-bold leading-headline0 md:text-landing-page-hero-desktop"
);

export const landingPageTagToClassNameMap: TagToClassNameMap = new Map([
  ["a", ""],
  ["ol", "mb-m last:mb-0 ml-m text-body-large"],
  ["ul", "mb-m last:mb-0 ml-m text-body-large"],
  ["p", "mb-m last:mb-0 text-body-large"],
  ["span", ""],
  ["div", "mb-m last:mb-0"],
  ["li", "list-disc list-outside mb-s last:mb-0"],
  ["h1", heroHeadlineFontStyle({ className: "mb-l last:mb-0" })],
  ["h2", "mb-m last:mb-0"],
  ["h3", "mb-s last:mb-0"],
  ["h4", "mb-xs last:mb-0"],
  ["h5", "mb-xs last:mb-0"],
  ["h6", "mb-xs last:mb-0"],
  ["hr", "mb-m last:mb-0"],
  ["br", "hidden md:block"],
  ["iframe", "absolute w-full h-full"],
]);
